import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { useDispatch } from 'react-redux';
import { TriggerFragments } from '../../graphql/trigger.graphql';
import { Trigger } from '../../types/trigger';
import { triggerSlice } from '../../providers/TriggerProvider';

const triggerSubscription = gql`
  subscription triggerNotification($companyId: String!) {
    triggerNotification(companyId: $companyId) {
      companyId
      entities {
        ...Trigger
      }
      topic
      date
    }
  }
  ${TriggerFragments.trigger}
`;

export class TriggerNotificationResponse extends forNotification<Trigger>('triggerNotification') {}

export default function TriggerNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useDispatch();

  if (!currentCompany) return null;

  const { data: triggerNotification } = useSubscription<TriggerNotificationResponse>(triggerSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleTriggerNotification = (notification?: TriggerNotificationResponse) => {
    if (!notification?.triggerNotification) return;
    const triggerNotification = notification.triggerNotification;

    switch (triggerNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(triggerSlice.actions.add(triggerNotification.entities));
        break;
      case 'DELETE':
        dispatch(triggerSlice.actions.delete(triggerNotification.entities));
    }
  };

  useEffect(() => {
    handleTriggerNotification(triggerNotification);
  }, [triggerNotification]);

  return <></>;
}
